import {
  isSensitiveKey,
  isUrlFieldKey,
  scrub,
  scrubExceptionMessage,
  scrubMessage,
  scrubUrlPath,
} from './sentryContextSanitizer';

function scrubExceptionValues(event) {
  const values = event.exception?.values;
  if (!Array.isArray(values)) {
    return;
  }

  values.forEach((exceptionData) => {
    if (exceptionData && typeof exceptionData.value === 'string') {
      exceptionData.value = scrubExceptionMessage(exceptionData.value);
    }
  });
}

function scrubRequest(event) {
  if (!event.request || typeof event.request !== 'object') {
    return;
  }

  const request = { ...event.request };
  delete request.data;
  delete request.cookies;
  delete request.env;
  delete request.query_string;
  delete request.query;
  request['http.query'] = undefined;

  if (typeof request.url === 'string') {
    request.url = scrubUrlPath(request.url);
  }

  if (request.headers && typeof request.headers === 'object') {
    const headers = { ...request.headers };
    Object.keys(headers).forEach((header) => {
      if (isSensitiveKey(header)) {
        headers[header] = '[redacted]';
        return;
      }
      if (isUrlFieldKey(header)) {
        headers[header] = scrubHeaderUrl(headers[header]);
      }
    });
    request.headers = headers;
  }

  event.request = request;
}

function scrubHeaderUrl(value) {
  if (Array.isArray(value)) {
    return value.map((item) => (typeof item === 'string' ? scrubUrlPath(item) : item));
  }

  return typeof value === 'string' ? scrubUrlPath(value) : value;
}

function isConsoleBreadcrumb(breadcrumb) {
  const category = breadcrumb?.category || '';
  return category === 'console' || category.startsWith('console') || Boolean(breadcrumb?.data?.arguments);
}

function scrubBreadcrumbs(event) {
  if (!Array.isArray(event.breadcrumbs)) {
    return;
  }

  event.breadcrumbs = event.breadcrumbs
    .filter((breadcrumb) => breadcrumb && typeof breadcrumb === 'object' && !isConsoleBreadcrumb(breadcrumb))
    .map((breadcrumb) => {
      const next = { ...breadcrumb };
      if (typeof next.message === 'string') {
        next.message = scrubMessage(next.message, next.category);
      }
      if (next.data && typeof next.data === 'object') {
        next.data = scrub(next.data);
      }
      return next;
    });
}

export function sentryBeforeSend(event) {
  if (!event) {
    return null;
  }

  scrubExceptionValues(event);

  if (event.extra && typeof event.extra === 'object') {
    event.extra = scrub(event.extra);
  }

  if (event.tags && typeof event.tags === 'object') {
    Object.keys(event.tags).forEach((key) => {
      if (isSensitiveKey(key)) {
        event.tags[key] = '[redacted]';
      }
    });
  }

  if (event.contexts && typeof event.contexts === 'object') {
    Object.keys(event.contexts).forEach((name) => {
      const context = event.contexts[name];
      if (context && typeof context === 'object') {
        event.contexts[name] = scrub(context);
      }
    });
  }

  scrubRequest(event);
  scrubBreadcrumbs(event);

  event.user = undefined;

  return event;
}
